import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ProgramPharmaciesAddPage } from './program-pharmacies-add';
import { MatFormFieldModule, MatInputModule, MatSelectModule, MatButtonModule } from '@angular/material';

@NgModule({
  declarations: [
    ProgramPharmaciesAddPage,
  ],
  imports: [
    IonicPageModule.forChild(ProgramPharmaciesAddPage),
    MatFormFieldModule, MatInputModule, MatSelectModule, MatButtonModule
  ],
})
export class ProgramPharmaciesAddPageModule {}



// WEBPACK FOOTER //
// ./src/pages/program-pharmacies-add/program-pharmacies-add.module.ts